import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAuditTableQueryDto } from 'src/app/models/IAuditTableQueryDto';
import { baseService } from '../base.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DataExplorerService extends baseService {


  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  private apiRoute: string = '';

  // TODO: Put in LighthouseService (but its also in Data Explorer as the UI is concerned)
  async getLogEntriesTimelineDetailsAsync(auditProfileId: string) {
    this.apiRoute = `auditlighthouse/${auditProfileId}/logentries/timeline/details`;
    return this.get(`/${this.apiRoute}`).toPromise();
  }

  async saveViewAsync(_: any) {
    this.apiRoute = `auditlighthouse/view`;
    return this.post(`/${this.apiRoute}`, _).toPromise();
  }

  async getLighthouseViewsAsync(databaseName: string) {
    this.apiRoute = `auditlighthouse/${databaseName}/views`;
    return this.get(`/${this.apiRoute}`).toPromise();
  }

  async getTableDataAsync(auditTableQuery: IAuditTableQueryDto) {
    this.apiRoute = `dataexplorer/tabledata`;
    return this.post(`/${this.apiRoute}`, auditTableQuery).toPromise();
  }

  //async deleteViewAsync(a: ILighthouseViewDto) {
  //  this.apiRoute = `auditlighthouse/view/delete`;
  //  return this.post(`/${this.apiRoute}`, a).toPromise();

  //  // deleteViewAsync(viewId: string)
  //  // this.apiRoute = `auditlighthouse/view/${viewId}`;
  //  // return this.post(`/${this.apiRoute}`).toPromise();
  //}

  async deleteViewAsync(viewId: string, databaseName: string) {
    this.apiRoute = `auditlighthouse/${databaseName}/view/${viewId}`;
    return this.delete(`/${this.apiRoute}`).toPromise();
  }

  // TODO: Put in LighthouseService (but its also in Data Explorer as the UI is concerned)
  async searchLogEntriesUserActivity(_: any) {
    this.apiRoute = `auditlighthouse/search/logentries/timeline/details`;
    return this.post(`/${this.apiRoute}`, _).toPromise();
  }

  // TODO: Put in LighthouseService (but its also in Data Explorer as the UI is concerned)
  async searchSoftDeletesLogEntriesUserActivity(_: any) {
    this.apiRoute = `auditlighthouse/search/logentries/timeline/details/soft-deletes`;
    return this.post(`/${this.apiRoute}`, _).toPromise();
  }

  async searchDatabaseJoinsAsync(auditProfileId: string) {
    this.apiRoute = `auditlighthouse/search/logentries/timeline/table/joins/${auditProfileId}`;
    return this.get(`/${this.apiRoute}`).toPromise();
  }

  async searchDatabaseSimilaritiesAsync(_: any) {
    this.apiRoute = `auditlighthouse/search/search/logentries/timeline/table/similarities`;
    return this.post(`/${this.apiRoute}`, _).toPromise();
  }

}
